export enum NeverChoice {
    Never = 'Never'
}
